<itl-text
  [(ngModel)]="value"
  [title]="node.title"
  [required]="node.mandatory"
  [description]="node.description"
  [disabled]="true"
  [required]="node.mandatory"
>
</itl-text>
